import { useDispatch } from "react-redux";
import { testCode } from "api/ExecutorServiceApi";
import { setContext } from "redux/actions/flowDesigner/editorContextActionCreator";

const useTestCode = () => {
  const dispatch = useDispatch();

  const runTestCode = async (setLogs, code, context) => {
    setLogs([]);

    const testCodeResult = await testCode(code, context);

    if (testCodeResult.isSuccessful) {
      setLogs(testCodeResult?.resultObject?.logs);
      dispatch(setContext(testCodeResult?.resultObject?.context));
    } else {
      setLogs([
        {
          message: testCodeResult?.error?.message,
          logType: "error",
        },
      ]);
    }
  };

  return { runTestCode };
};

export default useTestCode;
